<template>
  <div class="RegionSelect">
    <div>{{ content.footerText }}</div>
    <a class="modalLink" @click="showSelectRegionModal">
      <FlagIcon class="flagIcon" :locale="locale" />
      <span class="countryName">{{ countryName }}</span>
      <span v-html="regionSelectDropdownSvg" class="dropodownIcon"></span>
    </a>
    <ModalDialog class="modalDialog" :isVisible="modalIsVisible" :close="hideSelectRegionModal">
      <SelectRegionPane :title="content.modalTitle" />
    </ModalDialog>
  </div>
</template>

<script>
import localeInfo from '~/data/localeInfo.json'
import bodyScroll from '~/lib/bodyScroll.js'

import regionSelectDropdownSvg from './assets/region-select-dropdown.svg?raw'

import FlagIcon from '../FlagIcon.vue'
import ModalDialog from './ModalDialog.vue'
import SelectRegionPane from './SelectRegionPane.vue'

export default {
  components: {
    FlagIcon,
    ModalDialog,
    SelectRegionPane,
  },
  inject: ['locale'],
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      regionSelectDropdownSvg,
      modalIsVisible: false,
    }
  },
  computed: {
    countryName() {
      return localeInfo[this.locale].countryName
    },
  },
  methods: {
    showSelectRegionModal() {
      bodyScroll.lock()
      this.modalIsVisible = true
    },
    hideSelectRegionModal() {
      bodyScroll.unlock()
      this.modalIsVisible = false
    },
  },
}
</script>

<style scoped>
.RegionSelect {
  display: flex;
  color: var(--text-color-muted);
}
.modalLink {
  margin-left: var(--spacing-6);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}
.flagIcon {
  width: 27px;
}
.countryName {
  color: var(--text-color-intense);
}
.modalLink:hover .countryName {
  text-decoration: underline;
}
.modalDialog {
  --text-link-hover-color: #2A63A4;
}
</style>
